import styled from "@emotion/styled";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  min-height: 0;
  padding: 0 10px;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    font-weight: bold;
  }

  img {
    max-width: 60px;
    max-height: 60px;
  }

  .description {
    display: flex;
    flex-direction: column;
    font-size: 16px;
  }

  .text {
    color: #62748e;
    font-size: 12px;
    font-weight: normal;
  }
`;

export const CreateAndFilter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-shrink: 0;

  .divInput {
    display: flex;
    align-items: center;
    border: 1px solid #c4ccd8;
    border-radius: 8px;
    width: 100%;
    padding: 5px 10px;
    gap: 10px;
    color: #8f8f8f;
  }

  input {
    appearance: none;
    font-family: "Poppins";
    font-size: 12px;
    width: 100%;
    border: none;
    color: #544f77;
  }

  .buttonCreate {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 130px;
    border-radius: 8px;
  }
`;

export const MessagesList = styled.div`
  flex: 1;
  height: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 8px 12px 0 12px;
  gap: 4px;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const MessageCard = styled.button`
  width: 100%;
  max-width: 100%;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  padding: 8px 6px;
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  .symbol {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(15, 23, 43, 0.1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .symbol img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .content {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2px;
  }

  .topLine {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .name {
    display: block;
    flex: 0 1 auto;
    min-width: 0;
    max-width: calc(100% - 90px);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: #101828;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .shortcut {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-height: 22px;
    padding: 0 10px;
    border-radius: 999px;
    background: #eef2f6;
    color: #101828;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    flex-shrink: 0;
  }

  .message {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    font-size: 12px;
    line-height: 17px;
    color: #667085;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .divTrash {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .trashAction {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #dbe3f0;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(15, 23, 43, 0.06);
    color: #98a2b3;
    font-size: 14px;
    flex-shrink: 0;
    padding: 8px;
  }
`;

export const EmptyState = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #667085;
  font-size: 1.45rem;
  padding: 2rem;
`;

export const CreateForm = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  overflow: hidden;

  .fields {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 4px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
  }

  .fields::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  .fields::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }

  .field {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 2px;
  }

  .fieldMessage {
    flex: 1;
    min-height: 0;
  }

  .label {
    color: #8f8f8f;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .shortcutWrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .shortcutPrefix {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #544f77;
    font-size: 14px;
    line-height: 20px;
    z-index: 1;
  }

  .textareaWrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .checkboxField {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    color: #1d4ed8;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
  }

  .emojiButton {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
  }

  .footerActions {
    position: absolute;
    right: 12px;
    bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .characterCount {
    color: #8f8f8f;
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px 0 16px 0;
  }
`;

export const DeleteConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DeleteConfirmActions = styled.div`
  display: flex;
  justify-content: end;
  gap: 15px;
`;

export const FormInput = styled(InputText)`
  width: 100%;
  height: 40px;
  border: 1px solid #c4ccd8;
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  color: #544f77;

  &:enabled:focus {
    box-shadow: none;
    border-color: #c4ccd8;
  }
`;

export const ShortcutInput = styled(FormInput)`
  padding-left: 24px;
`;

export const FormTextarea = styled(InputTextarea)`
  width: 100%;
  min-height: 124px;
  border: 1px solid #c4ccd8;
  border-radius: 16px;
  box-shadow: none;
  font-size: 14px;
  color: #544f77;
  resize: none;
  padding: 14px 16px 34px 16px;
  overflow-y: hidden;

  &:enabled:focus {
    box-shadow: none;
    border-color: #c4ccd8;
  }
`;
